import React from 'react'

function ClosedAccountLayer() {
  return (
    <div>

    </div>
  )
}

export default ClosedAccountLayer
